import {
   CButton, CFormCheck, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter
} from '@coreui/react';

const UserSelectionModal = ({ title, visible, onClose, users, selectedUsers, onChange }) => {
   return (
      <CModal visible={visible} onClose={onClose}>
         <CModalHeader>
            <CModalTitle>{title}</CModalTitle>
         </CModalHeader>
         <CModalBody>
            {users.map((user) => (
               <CFormCheck
                  key={user.id}
                  label={`${user.first_name} ${user.last_name}`}
                  checked={selectedUsers.includes(user.id)}
                  onChange={(e) => onChange(user.id, e.target.checked)}
               />
            ))}
         </CModalBody>
         <CModalFooter>
            <CButton color="secondary" onClick={onClose}>
               Fechar
            </CButton>
         </CModalFooter>
      </CModal>
   );
};

export default UserSelectionModal;